<template>
    <div v-bind:class="readAccessClasses">
        <div class="na-Header">
            <div class="na-Filter">
                <div class="na-FilterCell">
                    <div class="na-FilterLabel">Bewertungsrunde:</div>
                    <div class="na-FilterBox">
                        <DxSelectBox :data-source="ratingTypeGroupSimpleList"
                                     :show-clear-button="true"
                                     display-expr="RtgName"
                                     value-expr="RtgId"
                                     v-model:value="selectedRtgId">
                        </DxSelectBox>
                    </div>
                </div>
            </div>
        </div>

        <div class="na-list">
            <DxDataGrid v-model:data-source="evaluationOverviewList"
                        :ref="gridKey"
                        @content-ready="gridContentReady"
                        @cell-prepared="gridCellPrepared"
                        :activeS-state-enabled="true"
                        :allow-column-reordering="true"
                        :allow-column-resizing="true"
                        :row-alternation-enabled="true"
                        @exporting="onExporting"
                        :show-borders="true">
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="true" />
                <DxScrolling row-rendering-mode="standard" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :allowed-page-sizes="100"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="true"
                                type="session"
                                :storage-key="gridKey"
                                :custom-load="loadState"
                                :custom-save="saveState" />
                <DxExport :enabled="true"
                          :allow-export-selected-data="true" />
                <DxToolbar>
                    <DxItem name="groupPanel" />
                    <DxItem name="searchPanel" />
                    <DxItem>
                        <DxButton icon="fas fa-plus" hint="Neues Thema anlegen" @click="addTopic"></DxButton>
                    </DxItem>
                    <DxItem name="exportButton" cssClass="mnExport" showText="false" />
                    <DxItem name="columnChooserButton"
                            locate-in-menu="auto"
                            location="after" />
                    <DxItem>
                        <DxButton icon="dx-icon dx-icon-clear" hint="Ansicht zurücksetzen" @click="resetState"></DxButton>
                    </DxItem>
                    <DxItem>
                        <DxButton icon="fas fa-sync" hint="Filter zurücksetzen" @click="resetFilter"></DxButton>
                    </DxItem>
                </DxToolbar>

                <!--<DxColumn caption='' :width="24" cell-template='actionTemplate' data-type="number" data-field='$id'
                :allow-filtering="false" :allow-header-filtering="false" :allow-resizing="false" :allow-sorting="false" :fixed="true"
                alignment="center" />-->
                <DxColumn name="Id" caption='ID' data-type="number" data-field='TopicId' :width="100" group-index="0" />
                <DxColumn name="Title" caption='Title' data-type='string' data-field='Title' cell-template="empty" width="125" />
                <DxColumn name="Expert" caption='Expert' data-type='string' data-field='ExpUsrFullName' />
                <DxColumn name="Average" caption='Average' data-type='number' data-field='ScoreWgtAvg'>
                    <DxFormat type="fixedPoint"
                              :precision="1" />
                </DxColumn>
                <DxColumn name="RatScoreAvg01" caption='RatScoreAvg01' data-type='number' data-field='RatScoreAvg01' cell-template="score" css-class="vtg-cell" />
                <DxColumn name="RatScoreAvg02" caption='RatScoreAvg02' data-type='number' data-field='RatScoreAvg02' cell-template="score" css-class="vtg-cell" />

                <DxGrouping>

                </DxGrouping>

                <DxSummary :calculate-custom-summary="calculateSummary"
                           :word-wrap-enabled="true">
                    <DxGroupItem name="Title"
                                 column="Title"
                                 summary-type="max"
                                 :align-by-column="true"
                                 display-format="{0}"
                                 show-in-column="Title" />
                    <DxGroupItem name="Average"
                                 column="Average"
                                 summary-type="avg"
                                 display-format="{0}"
                                 value-format="0.0"
                                 :align-by-column="true"
                                 show-in-column="Average" />
                    <DxGroupItem name="RatScoreAvg01"
                                 column="RatScoreAvg01"
                                 summary-type="avg"
                                 display-format="{0}"
                                 value-format="0.0"
                                 :align-by-column="true"
                                 show-in-column="RatScoreAvg01" />
                </DxSummary>
                <!--<DxStateStoring :enabled="true"
                type="localStorage"
                storage-key="storage" />-->

                <template #plainTemplate="{ data }">
                    {{data.value}}
                </template>
                <template #empty="{  }">
                </template>
                <template #score="{ data }">
                    <div v-bind:class="'vtg vtg-' + data.value"> {{data.value}}</div>
                </template>
                <template #actionTemplate="{data}">
                    <div class="pqMenu">
                        <DxMenu :data-source="rowMenuItems"
                                :cssClass="readAccessClasses"
                                items-expr="items"
                                orientation="horizontal"
                                :element-attr="{topicId: data.value}"
                                :hideSubmenuOnMouseLeave="true"
                                @item-click="function(e) { menuItemClick(e, data.value) }"
                                itemTemplate="itemTemplate"
                                show-first-submenu-mode="onHover">
                            <template #itemTemplate="{ data }">
                                <div v-bind:class="'mni-' + data.id">
                                    <div class="pq-menu-item">
                                        <i v-bind:class="data.icon"></i>
                                        <div class="pq-menu-txt">{{data.text}}</div>
                                    </div>
                                </div>
                            </template>
                        </DxMenu>
                    </div>
                    <!--<div class="pqMenuCell">
                        <i class="pqMenuElipsis fas fa-ellipsis-v">
                            <div class="pqMenu">
                                <div class="pqMnCommand" @click="viewTopic(data.value)"><i class="far fa-eye"></i>View</div>
                                <div v-if="access.allowUpdate" style="display:contents;">
                                    <div class="pqMnCommand" @click="editTopic(data.value)"><i class="fas fa-pen"></i>Edit</div>
                                </div>
                            </div>
                        </i>
                    </div>-->
                </template>
                <template #sfTemplate="{ data }">
                    <div>
                        <span v-html="data.value"></span>
                    </div>
                </template>
                <template #htmlTemplate="{ data }">
                    <div>
                        <span class="pqTooltip" v-html="data.value"></span>
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>
</template>
<script>
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxSummary,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxScrolling,
        DxSorting,
        DxPaging,
        DxPager,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGrouping,
        DxGroupPanel,
        DxToolbar,
        DxItem,
        DxGroupItem,
        DxExport,
        DxFormat
    } from 'devextreme-vue/data-grid'
    import DxSelectBox from 'devextreme-vue/select-box'
    import DxButton from 'devextreme-vue/button'
    import DxMenu from "devextreme-vue/menu"
    import axios from 'axios'
    const gridServiceUri = "WebApi.asmx/api/dataGrid"
    const gridKey = "TopicOverviewGridMain"
    const filterKey = gridKey + "Filter"

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'TopicOverview',
        components: {
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxGrouping,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxScrolling,
            DxSummary,
            DxSorting,
            DxSelectBox,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxColumn,
            DxGroupPanel,
            DxButton,
            DxToolbar,
            DxItem,
            DxExport,
            DxMenu,
            DxGroupItem,
            DxFormat
        },

        data() {
            return {
                filterList: [{ id: 0, text: 'Alle' },
                { id: 1, text: 'Von mir erstellt' },
                { id: 2, text: 'Mir zugeordnet' },
                ],
                filterValue: 0,
                selectedRtgId: 9,
                gridKey,
                filterKey,
                filter: {},
                storageKey: 'evaluationOverview',
                pageIndex: 0,
                isLoaded: false,
                rowMenuItems: [{
                    id: 1,
                    text: '',
                    icon: 'pqMenuElipsis fas fa-ellipsis-v',
                    visible: true,
                    items: [{ text: 'Lesen', id: 'view', icon: "ca-read far fa-eye", visible: true },
                    { text: 'Bearbeiten', id: 'edit', icon: "fas fa-pen", visible: true }]
                }],
            }
        },
        computed: {
            grid: function () {
                const ref = this.$refs[this.gridKey]
                if (ref) {
                    window.grid = ref.instance
                    return ref.instance
                }
                return null
            },
            evaluationOverviewList() {
                var result = this.$store.state.evaluationStore.evaluationOverviewList
                return result
            },
            columnList() {
                var result = this.$store.state.topicStore.columnList
                return result
            },
            ratingTypeGroupSimpleList() {
                var result = this.$store.state.ratingTypeGroupStore.ratingTypeGroupSimpleList
                return result
            },
            currentUsrId() {
                return this.$store.state.topicStore.currentUsrId
            },
            filterState: {
                cache: false,
                set: function (val) {
                    console.log("filterState-set")
                    localStorage.setItem(filterKey, JSON.stringify(val));
                },
                get: function () {
                    console.log("filterState-get")
                    const filter = localStorage.getItem(filterKey)
                    return filter > '' ? JSON.parse(filter) : null
                }
            },
            loaded() {
                return this.ratingTypeGroupSimpleList && this.ratingTypeGroupSimpleList.length > 0
            },
        },
        watch: {
            selectedRtgId: function () {
                this.loadData()
            },
            topicList: function () {
                if (this.grid != null)
                    this.grid.pageIndex(this.pageIndex)
            },
            filterValue: function () {
                this.loadData()
            },
            loaded: function (newVal, oldVal) {
                console.log("loaded-watch")
                if (!this.isLoaded && newVal && !oldVal) {
                    this.isLoaded = true
                    this.loadData()
                }
            },
        },
        mounted: function () {
            this.$store.dispatch("getRatingTypeGroupSimpleList", {})
            if (this.filterState) {
                this.filterValue = this.filterList.find(m => { return this.filterState.filterValue.id == m.id })
                this.selectedRtgId = this.filterState.selectedRtgId
            }
            else {
                this.filterValue = this.filterList[0]
            }
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            calculateSummary: function (options) {
                if (options.name === 'Average') {
                    switch (options.summaryProcess) {
                        case 'start':
                            options.totalValue = 0;
                            options.score = 0
                            options.weight = 0
                            break
                        case 'calculate':
                            options.score += options.value.ScoreAvg
                            break
                        case 'finalize':
                            options.totalValue = options.score
                            break
                    }
                }
            },
            resetFilter: function () {
                this.grid.clearFilter()
                this.filterValue = this.filterList[0]
                this.selectedRtgId = null
            },
            resetState: function () {
                this.grid.state(null)
            },
            addTopic: function () {
                window.location.href = window.location.pathname + "?action=createNew"
            },
            loadData: function () {
                if (!this.loaded) {
                    return
                }
                console.log("loadData")
                if (this.grid != null) {
                    console.log("beginUpdate")
                    this.grid.beginCustomLoading()
                }
                this.filterState = {
                    selectedRtgId: this.selectedRtgId,
                    filterValue: this.filterValue
                }
                const filter = {
                    RtgId: this.selectedRtgId,
                    Filter: this.filterValue ? this.filterValue.id : 0,
                }
                if (JSON.stringify(filter) != JSON.stringify(this.filter)) {
                    this.filter = filter
                    this.$store.dispatch("getEvaluationOverview", filter)
                }
            },
            viewTopic: function (data) {

                var rec = this.topicList.find(m => m.$id == data);
                this.grid.selectAll().done(x => {
                    const topicList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        window.location.href = window.location.pathname + "?action=view&id=" + rec.TopicId + "&list=" + topicList
                    })
                })
            },
            editTopic: function (data) {
                var rec = this.topicList.find(m => m.$id == data);
                // this.$router.push({ name: "TopicEntry", params: {   topicId: rec.TopicId  } })
                window.location.href = window.location.pathname + "?action=edit&id=" + rec.TopicId
            },
            loadStateX() {
                return axios.get(gridServiceUri + '/GetState', { params: { ControlName: "TopicOverview.vue", ViewName: "GrdMain" } })
                    .then(res => {
                        return res.data.Data
                    })
            },
            loadState() {
                const stateTxt = localStorage.getItem(this.storageKey)
                if (stateTxt && stateTxt > '') {
                    console.log("loadState")
                    var state = JSON.parse(stateTxt);
                    state.columns = state.columns.filter(m => {
                        return this.columnList.indexOf(u => {
                            return u.dataField == m.dataField
                        })
                    })
                    this.pageIndex = state.pageIndex
                    return state
                }
                else {
                    return null
                }
            },
            saveState(state) {
                console.log("saveState")
                if (state) {
                    for (let i = 0; i < state.columns.length; i++) {
                        state.columns[i].filterValue = null;
                    }
                }
                localStorage.setItem(this.storageKey, JSON.stringify(state));
            },
            gridContentReady() {
                this.grid.endCustomLoading()
            },
            gridCellPrepared(e) {
                if (e.rowType === "data" && e.column.dataField.startsWith("RatScoreAvg")) {
                    if (e.value !== null) {
                        e.cellElement.style.backgroundColor = e.value > 2 ? "green" : "red";
                    }
                }
            },
            menuItemClick(e, id) {
                switch (e.itemData.id) {
                    case "edit":
                        window.LoadPanel.Show()
                        this.editTopic(id)
                        return
                    case "view":
                        window.LoadPanel.Show()
                        this.viewTopic(id)
                        return
                }
            }
        }
    }
</script>
<style scoped>
    .mni-read, .mni-edit {
        display: none;
    }

    .frm-read .mni-view {
        display: block;
    }

    .frm-edit .mni-edit {
        display: block;
    }

    .na-FilterCell {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .na-Filter {
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    form .dx-loadpanel-content-wrapper * {
        display: none;
    }

    .mnExport div {
        background-color: var(--main-color-1);
        border-radius: 5px;
        height: 29px;
    }

        .mnExport div i:before {
            color: white;
        }

    .pqMenu .dx-menu-item-popout-container {
        display: none !important;
    }

    #app .pqMenu li {
        margin-left: -4px;
    }



    .vtg {
        text-align: center;
    }
</style>